const HeroBg = () => (
    <svg
        width='974'
        height='1165'
        viewBox='0 0 974 1165'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        id='hero-background'
    >
        <path
            opacity='0.8'
            d='M949.695 850.741L618.067 657.775L0 294.985L61.3125 189.741L679.379 552.531L1011 745.489L949.695 850.741Z'
            fill='url(#paint0_linear_259_1303)'
        />
        <path
            opacity='0.15'
            d='M697.04 813L491.7 693.601L109 469.121L146.964 404L529.664 628.48L735 747.874L697.04 813Z'
            fill='url(#paint1_linear_259_1303)'
        />
        <path
            d='M381.703 1163.35L382.187 779.594L383.013 170.947L505.662 171.121L504.836 779.767L504.345 1163.51L381.703 1163.35Z'
            fill='url(#paint2_linear_259_1303)'
        />
        <path
            d='M632.478 934.835L632.318 571.252L632.103 -5.39559L753.929 -5.37169L754.144 571.269L754.304 934.845L632.478 934.835Z'
            fill='url(#paint3_linear_259_1303)'
        />
        <path
            d='M772.885 987.031L773.74 603.278L775.118 -5.36205L842.394 -5.65304L841.016 602.979L840.161 986.726L772.885 987.031Z'
            fill='url(#paint4_linear_259_1303)'
            fillOpacity='0.15'
        />
        <path
            d='M583 495.246V634.741L505.654 589.823L383 518.573V153H505.654V450.321L583 495.246Z'
            fill='url(#paint5_linear_259_1303)'
            fillOpacity='0.8'
            style={{ mixBlendMode: 'screen' }}
        />
        <path
            d='M633 666.741L755 600.441V43.741L633 118.355V666.741Z'
            fill='#00FFFF'
            style={{ mixBlendMode: 'soft-light' }}
        />
        <defs>
            <linearGradient
                id='paint0_linear_259_1303'
                x1='89.2059'
                y1='272.841'
                x2='905.843'
                y2='762.636'
                gradientUnits='userSpaceOnUse'
            >
                <stop stopColor='#00A6FF' stopOpacity='0' />
                <stop offset='0.520833' stopColor='#00A6FF' />
                <stop offset='1' stopColor='#00A6FF' stopOpacity='0' />
            </linearGradient>
            <linearGradient
                id='paint1_linear_259_1303'
                x1='164.235'
                y1='455.419'
                x2='669.702'
                y2='758.793'
                gradientUnits='userSpaceOnUse'
            >
                <stop stopColor='#00A6FF' stopOpacity='0' />
                <stop offset='0.520833' stopColor='#00A6FF' />
                <stop offset='1' stopColor='#00A6FF' stopOpacity='0' />
            </linearGradient>
            <linearGradient
                id='paint2_linear_259_1303'
                x1='444'
                y1='182.5'
                x2='443.943'
                y2='819.5'
                gradientUnits='userSpaceOnUse'
            >
                <stop stopColor='#00A6FF' stopOpacity='0' />
                <stop offset='0.329196' stopColor='#00A6FF' />
                <stop offset='1' stopColor='#00A6FF' stopOpacity='0' />
            </linearGradient>
            <linearGradient
                id='paint3_linear_259_1303'
                x1='706.048'
                y1='61.9648'
                x2='692.164'
                y2='872.907'
                gradientUnits='userSpaceOnUse'
            >
                <stop stopColor='#00A6FF' stopOpacity='0' />
                <stop offset='0.520833' stopColor='#00FFFF' />
                <stop offset='1' stopColor='#00A6FF' stopOpacity='0' />
            </linearGradient>
            <linearGradient
                id='paint4_linear_259_1303'
                x1='815.778'
                y1='65.5435'
                x2='791.8'
                y2='921.115'
                gradientUnits='userSpaceOnUse'
            >
                <stop stopColor='#00A6FF' stopOpacity='0' />
                <stop offset='0.520833' stopColor='#00FFFF' />
                <stop offset='1' stopColor='#00A6FF' stopOpacity='0' />
            </linearGradient>
            <linearGradient
                id='paint5_linear_259_1303'
                x1='483'
                y1='183.5'
                x2='483'
                y2='778.5'
                gradientUnits='userSpaceOnUse'
            >
                <stop stopColor='#00A6FF' stopOpacity='0' />
                <stop offset='1' stopColor='#00A6FF' />
            </linearGradient>
        </defs>
    </svg>
);

export default HeroBg;
